<template>
    <!--<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">-->



    <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-50">
        <h3>Core Details</h3>
        <p class="margin_bottom">Core details for {{entityDescription}}</p>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Name
            </label>
            <div class="md-layout-item md-size-40">
                <ValidationProvider name="Name" rules="required|min:5|max:100" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input v-model="details.name" type="text" autocomplete="new-name" placeholder="Company Name"></md-input>
                        <span class="md-helper-text">5-100 characters <a :href="longerNameUrl" title="Contact support" class="a_default">Need longer name for billing?</a></span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>


        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Publish
            </label>
            <div class="md-layout-item md-size-75 pad_top">
                <md-checkbox v-model="details.publish">Allow display on websites. Recommended</md-checkbox>
                <span class="md-helper-text">Deselect for exceptional circumstances {{unPublishEg}}</span>
            </div>
        </div>

        <div class="md-layout md-gutter" v-if="details.publish">
            <label class="md-layout-item md-size-25 md-form-label">
                {{descriptionLabel}}
            </label>
            <div class="md-layout-item">
                <ValidationProvider :name="descriptionLabel" rules="required|min:15|max:300" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-textarea v-model="details.description" md-autogrow></md-textarea>
                        <span class="md-helper-text">Suitable description for websites (15-300 characters)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min, max } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);

    export default {
        name: "CompanyDetails",
        components: {
            SlideYDownTransition
        },
        props: {
            details: {
                name: null,
                description: null,
                publish: null,
            },
            entityDescription: null,
            unPublishEg: null,
            descriptionLabel: {
                type: String,
                default: "Description"
            }
        },
        computed:
        {
            longerNameUrl() {
                return encodeURI(`mailto:support@unitview.co.uk?subject=Company Details | Longer Name Required`);
            },
        }

    };
</script>
